module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-11-b4a38b19ac085486b02a7343058c4328.webp";